/**
 * Ride-message templates — frontend mirror of `services/ride_messages.py`.
 *
 * Why a mirror?
 *   The preset chips need to render BEFORE the first GET resolves so the
 *   driver/passenger doesn't see a flash of empty controls when opening
 *   the chat. The backend remains the canonical source (and validates
 *   every send against its own copy), so a divergence is a no-op for
 *   correctness — the worst case is a stale chip on an old client,
 *   which the server rejects with a 400.
 *
 *   If you change keys here, mirror them in
 *   `backend/services/ride_messages.py::TEMPLATES_BY_ROLE`.
 */
export const PASSENGER_TEMPLATES = [
  { id: "where_are_you",   body: "Where are you?" },
  { id: "im_outside",      body: "I'm outside." },
  { id: "be_2_min",        body: "I'll be 2 minutes." },
  { id: "please_call_me",  body: "Please call me." },
  { id: "at_pickup_point", body: "I'm at the pickup point." },
];

export const DRIVER_TEMPLATES = [
  { id: "arriving_now",    body: "I'm arriving now." },
  { id: "im_outside",      body: "I'm outside." },
  { id: "late_2_min",      body: "Running 2 minutes late." },
  { id: "come_to_pickup",  body: "Please come to the pickup point." },
  { id: "cannot_find_you", body: "I cannot find you." },
];

export function templatesForRole(role) {
  if (role === "passenger") return PASSENGER_TEMPLATES;
  if (role === "driver")    return DRIVER_TEMPLATES;
  return [];
}
